import { render, staticRenderFns } from "./draggableTextBtn.vue?vue&type=template&id=16f1bc0e&scoped=true&"
import script from "./draggableTextBtn.vue?vue&type=script&lang=js&"
export * from "./draggableTextBtn.vue?vue&type=script&lang=js&"
import style0 from "./draggableTextBtn.vue?vue&type=style&index=0&id=16f1bc0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f1bc0e",
  null
  
)

export default component.exports